import gql from 'graphql-tag';

const SET_MYSTAGE_THEME = gql`
  mutation setMystageTheme($color: Int!) {
    setMystageTheme(color: $color)
  }
`;

const SET_HIDE_MYSTAGE_RECORD_MESSAGE = gql`
  mutation setHideMystageRecordMessage($value: Int!) {
    setHideMystageRecordMessage(value: $value)
  }
`;

export { SET_MYSTAGE_THEME, SET_HIDE_MYSTAGE_RECORD_MESSAGE };
